// extracted by mini-css-extract-plugin
export default {"launchCalendarTab":"I-z","nav":"J-z","heading":"K-z","active":"L-z","mainCard":"M-z"};